module.exports = __webpack_public_path__ + "img/phse.8188abed.png";